import React from 'react'
import PropTypes from 'prop-types'
import LocalizedLink from '../../global/LocalizedLink'
import style from './style/banner_bathroom_days_promo_style.module.scss';
import esLarge from './assets/es-ecosentino-bathroom-days-large.png'
import esSmall from './assets/es-ecosentino-bathroom-days-small.png'
import ptLarge from './assets/pt-ecosentino-bathroom-days-large.png'
import ptSmall from './assets/pt-ecosentino-bathroom-days-small.png'

const BannerBathroomDaysPromotion = ({ canViewBathroomDayPromotion, isCatalog = false }) => {
    const { inPortugal, inSpain } = canViewBathroomDayPromotion

    /* if (!inPortugal && !inSpain) {
        return null
    } */

    const isMobile = window.innerWidth <= 768

    let image = null

    if (isCatalog) {
        image = inPortugal
            ? (isMobile ? ptSmall : ptLarge)
            : (isMobile ? esSmall : esLarge)
    } else {
        image = inPortugal ? ptSmall : esSmall
    }

    return (
        <div className={`${style['banner-bathroom-days-promo']}${isCatalog ? ` ${style['banner-bathroom-days-promo--catalog']}` : ''}`}>
            <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=BASIN&type[1]=VANITY&type[2]=STRAY" params={{ outlet: '' }}>
                {isCatalog ? (
                    <img src={image} alt="Bathroom Days Promotion" />
                ) : (
                    <div
                        className={style['banner-bathroom-days-promo__image']}
                        style={{ backgroundImage: `url(${image})` }}
                    />
                )}
            </LocalizedLink>
        </div>
    )
}

BannerBathroomDaysPromotion.propTypes = {
    canViewBathroomDayPromotion: PropTypes.shape({
        inPortugal: PropTypes.bool,
        inSpain: PropTypes.bool,
    }).isRequired,
    isCatalog: PropTypes.bool,
}

BannerBathroomDaysPromotion.defaultProps = {
    isCatalog: false,
}

export default BannerBathroomDaysPromotion
